import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ProjectState {
  id: number | null;
}

const initialState: ProjectState = {
  id: null,
};

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    /**
     * @description
     * Redux action to set the currently selected project id.
     * @param action `number | null` - The project id to set.
     * @example
     * ```ts
     * dispatch(projectSliceActions.setId(123));
     * ```
     */
    setId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
    unsetId: (state) => {
      state.id = null;
    },
  },
});

// Private actions are used internally by redux-state package only.
// This is to avoid having these values set in unintentional locations.
export const projectSlicePrivateActions = {
  setId: projectSlice.actions.setId,
  unsetId: projectSlice.actions.unsetId,
};

// Public actions can be used by any consumer of the redux-state package.
export const projectSlicePublicActions = {};

export default projectSlice;
